import { IntegrationsCaseParam } from '../../model'
import { IntegrationCaseData } from '../types'

import AnnounceIcon from '~shared/icons/24/announce.svg'
import BrainIcon from '~shared/icons/24/brain.svg'
import ExportIcon from '~shared/icons/24/export.svg'
import GobletIcon from '~shared/icons/24/goblet.svg'
import SightIcon from '~shared/icons/24/sight.svg'

export function createWinLossCase(integrationName: string): IntegrationCaseData {
  return {
    value: IntegrationsCaseParam.WIN_LOSS,
    title: 'Win/loss',
    description: `Extract and visualize win/loss performance vs. each of your key competitors from ${integrationName} CRM. Use Ignition’s tools to easily filter and parse key insights into why you’re winning and losing deals.`,
    aspects: [
      'Visualize win/loss performance',
      'Identify key win/loss drivers',
      'Use AI to parse insights into how to win more deals',
    ],
    getIcon: () => <GobletIcon />,
  }
}

export function createBattleCardsCase(): IntegrationCaseData {
  return {
    value: IntegrationsCaseParam.BATTLE_CARDS,
    title: 'Battlecards',
    description:
      'Export battlecards, launch calendars, and other key information directly to a widget inside your CRM, so Sales teams can easily access the info they need to close deals.',
    aspects: [
      'Embed a widget inside your opportunities',
      'Surface login-free access to battlecards, launch calendars, and more',
    ],
    getIcon: () => <ExportIcon />,
  }
}

export function createProductGapsCase(integrationName: string): IntegrationCaseData {
  return {
    value: IntegrationsCaseParam.PRODUCT_GAPS,
    title: 'Product Gaps',
    description: `Use Ignition’s AI to help automatically identify feature gaps blocking your sales deals from ${integrationName} deal notes and call data, then quantify their revenue impact based on blocked deals, and close the loop with reps when they ship.`,
    aspects: [
      'Identify critical deal blockers with AI',
      'Quantify product roadmap effort based on revenue',
      'Capture open pipeline opportunity by notifying reps when features ship',
    ],
    getIcon: () => <BrainIcon />,
  }
}

export function createVoiceOfCustomerCase(): IntegrationCaseData {
  return {
    value: IntegrationsCaseParam.VOICE_OF_CUSTOMERS,
    title: 'Voice of Customer',
    description:
      "Sync customer conversations and insights into your VoC tab, and use Ignition's AI to extract key takeaways like common feature requests, messaging suggestions, and more.",
    aspects: [
      'Sync customer conversations for a single source of truth',
      'Extract takeaways and themes with AI',
      'Connect insights to roadmap items for context',
    ],
    getIcon: () => <SightIcon />,
  }
}

export function createNotificationCase(integrationName: string): IntegrationCaseData {
  return {
    value: IntegrationsCaseParam.NOTIFICATIONS,
    title: 'Notifications',
    description:
      'Send and receive notifications directly within your messaging app. Use the Share Update feature in GTM plans to push automated status updates to a channel or individual, or receive personal notifications for plans you’re following.',
    aspects: [
      'Automate internal comms for launch enablement',
      `Comment and approve plans & assets within ${integrationName}`,
      'Receive personal notifications',
    ],
    getIcon: () => <AnnounceIcon />,
  }
}
